import axios from 'axios';

const version = 'v1';
const basePath = 'working-order';

export async function create(recipient, request_id) {
  return axios.request({
    url: `/${version}/${basePath}/`,
    method: 'post',
    data: {
      recipient,
      request_id,
    },
  });
}
